import { render } from "./VehicleBpmCard.vue?vue&type=template&id=b35ff86c"
import script from "./VehicleBpmCard.vue?vue&type=script&lang=js"
export * from "./VehicleBpmCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__